import {useContext} from 'react';
import {ModalContext} from 'extensions/viewport/ModalContext';

export function useModal() {
  return useContext(ModalContext);
}
